import React, { useEffect, useMemo, useState ,useRef} from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik, yupToFormErrors } from "formik"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import toastr from "toastr"
import {
  getUsers as onGetUsers,
  addNewUser as onAddNewUser,
  updateUser as onUpdateUser,
  deleteUser as onDeleteUser,
} from "../../store/actions"



//redux
import { useSelector, useDispatch } from "react-redux"
import axios from "../../axios"
import Select from "react-select";
import numeral from "numeral";
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  CardTitle,
Table,
Button,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { makeStyles } from '@material-ui/core/styles';
import DeleteModal from "../../components/Common/DeleteModal"
import SweetAlert from "react-bootstrap-sweetalert";
import Switch from "react-switch"
import { Dialog, DialogTitle } from "@material-ui/core";
import Backdrop from '@material-ui/core/Backdrop';
import  Spinner  from 'react-spinkit'
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
function DatatableTables() {
  const [modal, setModal] = useState(false)
  // const [modal1, setModal1] = useState(false);
  const [isEdit, setIsEdit] = useState(false)
  const classes = useStyles();
  const [userList, setUserList] = useState([])
  const [user, setUser] = useState([])
  const [duplicateerro, setduplicateerro] = useState(false)
  const [coutrysuccess, setcoutrysuccess] = useState(false);
  const [countryerror, setcountryerror] = useState(false);
  const [countryinfo, setcountryinfo] = useState(false);
  const [deletid, setdeletid] = useState('')
  const [switch1, setswitch1] = useState(true)
  const [tokent, settokent] = useState('Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ')
const [allqaparameter, setallqaparameter] = useState([])
const [allcategorycollections, setallcategorycollections] = useState([])
const [allproductscollection, setallproductscollection] = useState([])
const [categrid, setcategrid] = useState('')
const [allpriuomcollection, setallpriuomcollection] = useState([])
const [priuomid, setpriuomid] = useState('')
const [allsecondaryuomcollection, setallsecondaryuomcollection] = useState([])
const [secuomid, setsecuomid] = useState('')
const [allbrandcollections, setallbrandcollections] = useState([])
const [brandid, setbrandid] = useState('')
const [alltaxcollections, setalltaxcollections] = useState([])
const [taxid, settaxid] = useState('')
const [hsncode, sethsncode] = useState('')
const [categoryfilter, setcategoryfilter] = useState([])
const categoryref = useRef('')
const priuomref = useRef('')
const secondaryuomref = useRef('')
const brandref = useRef('')
const vatref = useRef('')
const [open, setopen] = useState(false)
const [categorydefaultvalue, setcategorydefaultvalue] = useState({label:"Select...", value:""})
const [priuomdefaultvalue, setpriuomdefaultvalue] = useState({label:"Select...", value:""})
const [secondaryuomdefaultvalue, setsecondaryuomdefaultvalue] = useState({label:"Select...", value:""})
const [branddefaultvalue, setbranddefaultvalue] = useState({label:"Select...", value:""})
const [vatpercentagedefaultvalue, setvatpercentagedefaultvalue] = useState({label:"Select...", value:""})
const [proid, setproid] = useState('')
const [gsterror, setgsterror] = useState(false)
const [categoryerror, setcategoryerror] = useState(false)
const [secondaryuomerror, setsecondaryuomerror] = useState(false)
const [priuomderror, setpriuomderror] = useState(false)
const [buyerattcheload, setbuyerattcheload] = useState({Imagepath:''})
const [buyerattchenamte, setbuyerattchenamte] = useState('')
const [buyerattch, setbuyerattch] = useState(null)
const [branderror, setbranderror] = useState(false)
const [Poupuimage, setPoupuimage] = useState('')
const [dialogbox, setdialogbox] = useState(false)
const [productvalue, setproductvalue] = useState('')
const [ratecodevalue, setratecodevalue] = useState('')
const [cusid, setcusid] = useState('')
const [alltransportcollections, setalltransportcollections] = useState([])
const [customererrors, setcustomererrors] = useState(false)
const [customerdefaultvalue, setcustomerdefaultvalue] = useState({label:"Select...", value:""})
const [stateid, setstateid] = useState('')
const [statedefaultvalue, setstatedefaultvalue] = useState({label:"Select...", value:""})
const [onestatecolletions, setonestatecolletions] = useState([])
const [allproductslists, setallproductslists] = useState({
    Transport_Name:"",
    Transport_Code:"",
    Customer_Id:"",
    Contact_Person:"",
    Address1:"",
    Address2:"",
    Area_Code:"",
    City:"",
    Zip_Code:"",
    State:"",
    Country:"",
    Phone:"",
    Fax:"",
    EmailId:"",
    TIN_No:"",
    Created_By:"",
    Created_Date:"",
    Transport_Id:"",
    StateCode:"",
    StateId:"",
    PANNo:""
    
})




const PhoneRegExps = /^[0-9 () +-]+$/
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues:allproductslists, 
  
    validationSchema: Yup.object({
        Transport_Name: Yup.string().required("Please Enter Transport Name"),
        Contact_Person: Yup.string().required("Please Enter Contact Person"),
        City:Yup.string().matches(/^[aA-zZ\s]+$/,"Please Enter Valid City "),
        Area_Code:Yup.string().min(3,'Pin Code Must Be atleast 3 Digits').max(6,'Pin Code Must Be atleast 6 Digits'),
       
        Country:Yup.string().matches(/^[aA-zZ\s]+$/,"Please Enter Valid Country "),
        Phone:Yup.string().min(10, 'Phone No Must Be Atleast 10 Digits').max(20,'Phone No Must Be Atmost 20 Digits').matches(PhoneRegExps, 'Please Enter valid Phone No'),
        
        EmailId:Yup.string().email('Mail Id Must Be Valid'),

    }),
    onSubmit: async (values) => {
      if (isEdit) {
     

        
        const update = await axios.instance.put(`/Updatetransport/${proid}`,  {
  
            Transport_Name:values.Transport_Name,
            // --Transport_Code,
            Customer_Id:cusid,
            Contact_Person:values.Contact_Person,
            Address1:values.Address1,
            Address2:values.Address2,
            Area_Code:values.Area_Code,
            City:values.City,
            Zip_Code:values.Zip_Code,
            State:stateid,
            Country:values.Country,
            Phone:values.Phone,
            Fax:values.Fax,
            EmailId:values.EmailId,
            TIN_No:values.TIN_No,
            Modify_By:  localStorage.getItem('UserId'),
            Modify_Date:new Date(),
            StateCode:statecode,
            StateId:satenme,
            PANNo:values.PANNo
      
           },{ headers: {'Authorization':tokent,
           'Content-Type': 'application/json'
           }}).then((res) => {
        // update user
        if(res.data === '') {
          GetallTransport()
          toggle()
                setcountryinfo(true)
             
              validation.resetForm()
        }else {
          setduplicateerro(true)
        }
      
      })
     
        
      } else {
          if(cusid.length!=0) {

        
        const createoneuser = await axios.instance.post('/Inserttransport',  {
           OpType:"New",
 
            Transport_Name:values.Transport_Name,
            // --Transport_Code,
            Customer_Id:cusid,
            Contact_Person:values.Contact_Person,
            Address1:values.Address1,
            Address2:values.Address2,
            Area_Code:values.Area_Code,
            City:values.City,
            Zip_Code:values.Zip_Code,
            State:stateid,
            Country:values.Country,
            Phone:values.Phone,
            Fax:values.Fax,
            EmailId:values.EmailId,
            TIN_No:values.TIN_No,
            Created_By:localStorage.getItem('UserId'),
            Created_Date: new Date(),
            
            StateCode:statecode,
            StateId:satenme,
            PANNo:values.PANNo
           },{ headers: {'Authorization':tokent,
           'Content-Type': 'application/json'
           }}).then((res) => {
             //console.log(res.data)
            
           if(res.data.length === 1 ){
            setcoutrysuccess(true)
     
            //console.log(res.data)  
            GetallTransport()
      validation.resetForm()
            toggle()
           } else{
             setduplicateerro(true)
           }
           //toastr.success('Garment Description Added Successfully', 'Garment')
           
          })  
        }else{
            if(cusid.length === 0) {
                setcustomererrors(true)
               
              }
              setTimeout(() => {
                  setcustomererrors(false)
              }, 2000);
        }
      }
     
      
     
      setDeleteModal(false)
     
    },
  })
  // const toggleViewModal = () => setModal1(!modal1);


  const toggle = () => {
    if (modal) {
      setModal(false)
    
setcustomerdefaultvalue({label:"Select...",value:""})
setcusid('')
      setUser(null)
      validation.resetForm()
      setallproductslists(
        {
            Transport_Name:"",
         
            Customer_Id:"",
            Contact_Person:"",
            Address1: "",
            Address2:"",
            Area_Code:"",
            City:"",
            Zip_Code:"",
            State:"",
            Country:"",
            Phone:"",
            Fax:"",
            EmailId:"",
            TIN_No:"",
            Transport_Id:"",
            StateCode:"",
            StateId:"",
            PANNo:""
         }
      )
    } else {
      setModal(true)
      setcusid('')
    }
  }  
  const Getonestates = async() => {
    const get= await axios.instance.get('/Getonestate',{ headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then((res) => {
      setonestatecolletions(res.data)
      for(const data of res.data)
      {
        setstatedefaultvalue({label:data.StateName,value:data.StateId})
         setstateid(data.StateName)
         setsatenme(data.StateId)
         setstatecode(data.StateCode)
      }
    })
    }

  const handleUserClick = async (arg) => {
//console.log(arg)

    const qapara = arg
    //console.log('t', arg)
    setproid(qapara.Category_Id)
  
   //console.log
    setallproductslists(
      {
        Transport_Name:qapara.Transport_Name,
        // --Transport_Code,
        Transport_Id:qapara.Transport_Id,
        Contact_Person:qapara.Contact_Person,
        Address1:qapara.Address1,
        Address2:qapara.Address2,
        Area_Code:qapara.Area_Code,
        City:qapara.City,
        Zip_Code:qapara.Zip_Code,
        State:qapara.State,
        Country:qapara.Country,
        Phone:qapara.Phone,
        Fax:qapara.Fax,
        EmailId:qapara.EmailId,
        TIN_No:qapara.TIN_No,
       
        
        StateCode:qapara.StateCode,
        StateId:qapara.StateId,
        PANNo:qapara.PANNo
       
       }
    )
    setcusid(qapara.Customer_Id)
//console.log('cuss', qapara.Customer_Id)
setstatedefaultvalue({label:qapara.State,value:qapara.StateId})
  ////console.log(qapara.Imagepath)
  //  validation.values.CGSTPer =arg.VAT_Percentage
  //  validation.values.SGSTPer =arg.VAT_Percentage
  setcustomerdefaultvalue({label:qapara.Customer_Name,value:qapara.Customer_Id})


//console.log(qapara.Customer_Id)
    const deleteoneuser = await axios.instance.get(`/Getonecustomer/${qapara.Customer_Id}`,{ headers: {'Authorization':tokent,
    'Content-Type': 'application/json'
    }}).then((res)=>{
        //console.log(qapara.Customer_Id,'cust')
        console.Console
      for(const data of res.data) {
      
      
      
      
      }

    // Categoryref.current.select.commonProps.setValue({
    //   label:defects.CategoryDescription,
    //   value:defects.CategoryId

    })
   

   // set({label:defects.Buyer,value:defects.BuyerId})





    setIsEdit(true)

    toggle()
  }

  //delete user
  const [deleteModal, setDeleteModal] = useState(false)
  const [allsupplierinfo, setallsupplierinfo] = useState([])
  const [allstates, setallstates] = useState([])
  const [satenme, setsatenme] = useState('')
  const [statecode, setstatecode] = useState('')
  const onClickDelete = user => {
    setdeletid(user.Transport_Id)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (user.id) {
      dispatch(onDeleteUser(user))
      setDeleteModal(false)
    }
  }
  const handleUserClicks = () => {
    setUserList("")
    setIsEdit(false)
    toggle()
  }
  useEffect(() => {
    GetallTransport()
    Getallstates()
    Getallsuppliervalue()
    Getonestates()
  }, []);
  const Countrydelete =  async() => {
    const deleteoneuser = await axios.instance.delete(`/Deletetransport/${deletid}`,{ headers: {'Authorization':tokent,
    'Content-Type': 'application/json'
    }}).then((res)=>{
   if(res.data === '') {

   
   ////console.log(res.data)
   GetallTransport()
    setDeleteModal(false)
    //toastr.error ('User Deleted Successfully', 'User')
    setcountryerror(true)
  }else {
      toastr.error('Already Used Cannot be Deleted','Transport')
      setDeleteModal(false)
    }
})
  }
 
 

const getcustomid = (id) => {
    setcusid(id)
}

const getstateid = (id) => {
//console.log(id)
  setstateid(id.label)
  setsatenme(id.value)
  setstatecode(id.value)
}


const Closepopup = () => {
  setopen(false)
}


const Getallsuppliervalue = async() => {
    const get= await axios.instance.get(`/Getonesuppliers/${localStorage.getItem('CompanyId')}`,{ headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then((res) => {
      
      const data  =res.data
      const options = data.map(b => ( {
      'label' : b.Customer_Name,
      'value' : b.Customer_Id
      }))

setallsupplierinfo(options)
    })
    }

    const Getallstates = async() => {
      const get= await axios.instance.get('/GetallStates',{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
      
      }}).then((res) => {
        
        const data  =res.data
        const options = data.map(b => ( {
        'label' : b.StateName,
        'value' : b.StateId
        }))
  
  setallstates(options)
      })
      }

    const GetallTransport = async() => {
        const get= await axios.instance.get('/GetallTransport',{ headers: {'Authorization':tokent,
        'Content-Type': 'application/json',
        
        }}).then((res) => {
          setalltransportcollections(res.data)
        })
        }
  const columns = useMemo(
    () => [
    
      {
        Header: "Transport Name",
        accessor: "Transport_Name",
        disableFilters: true,
        filterable: true,
      
      },
   

      // {
      //   Header:"Transport Code",
      //   accessor:"Transport_Code",
      //   filterable:false,
      //   disableFilters: true,
      // },

    //   {
    //     Header: "MRP",
    //     accessor: cellProps => (
    //       <React.Fragment>
            
    //         {numeral(cellProps.MRP_Rate).format('0,0.00')}
    //       </React.Fragment>
    //     ),
    //     filterable: false,
    //     disableFilters: true,
    //   },
    //   {
    //     Header: "Purchase Price",
    //     accessor: cellProps => (
    //       <React.Fragment>
            
    //         {numeral(cellProps.Purchase_Rate).format('0,0.00')}
    //       </React.Fragment>
    //     ),
    //     filterable: false,
    //     disableFilters: true,
    //   },
    
    //   {
    //     Header: "Sales Price",
    //     accessor: cellProps => (
    //       <React.Fragment>
            
    //         {numeral(cellProps.Sales_Rate).format('0,0.00')}
    //       </React.Fragment>
    //     ),
    //     filterable: false,
    //     disableFilters: true,
    //   },


    //   {
    //     Header: "Photo ",
    //     // accessor: "name",
    //     filterable: false,
    //     disableFilters: true,

    //     accessor: cellProps => (
    //       <React.Fragment>
            
    //         <Link to="#" className="text-body">

    //           {cellProps.Imagepath != '' ?  (
    //             <img src={cellProps.Imagepath}  width='50px' height='50px'   onClick={() => debugBase64(cellProps.Imagepath)}/>
    //           ): 
    //           <p>No Image</p>
    //           }
    //         </Link>
    //       </React.Fragment>
    //     ),
    //   },


      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={() => {
                      const users = cellProps.row.original
                      handleUserClick(users)
                    }}
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const users = cellProps.row.original
                      onClickDelete(users)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
                {/* <li className="list-inline-item dropdown">
                  <UncontrolledDropdown>
                    <DropdownToggle
                      tag="a"
                      className="text-muted font-size-18 px-2"
                      caret
                    >
                      <i className="uil uil-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem href="#">Action</DropdownItem>
                      <DropdownItem href="#">Another action</DropdownItem>
                      <DropdownItem href="#">Something else here</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li> */}
              </ul>
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={Countrydelete}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Master" breadcrumbItem="Transport Master" />
          <Row>
          <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={alltransportcollections}
                    isGlobalFilter={true}
                    isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit Transport" : "Add Transport"}
            </ModalHeader>
            <ModalBody>
            <Row>
                                <Col lg="3">
                                  <div className="mb-3">
                                    <Label  for="basicpill-firstname-input1">
                                   Name
 
                                </Label>
                                    <Input
                                        autoComplete="off"
                                      type="text"
                                      className="form-control"
                                      id="basicpill-firstname-input1"
                                    name="Transport_Name"
                                    
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.Transport_Name || ""}
                                      invalid={
                                        validation.touched.Transport_Name && validation.errors.Transport_Name ? true : false
                                      }
                                    />
                              {validation.touched.Transport_Name && validation.errors.Transport_Name ? (
                          <FormFeedback type="invalid">{validation.errors.Transport_Name}</FormFeedback>
                        ) : null}
                                  </div>
                                </Col>
                               
                                <Col lg="3">
                            <div className="mb-3">
                              <Label htmlFor="manufacturerbrand">
                              <b>Customer </b>
                              </Label>
                              <Select
                                name="CategoryId"
                        options={allsupplierinfo}
                       //ref={categoryref}
                     classNamePrefix="select2-search-disable"
                    onChange={(value)=>  getcustomid(value.value)}
                   defaultValue={customerdefaultvalue}
                   />   
                                       {customererrors ? <p   style={{fontSize:"12px"}} className="error">Please Select Customer </p> :  null}
                  
                            </div>
                          </Col>
                                <Col lg="3">
                                  <div className="mb-3">
                                    <Label for="basicpill-lastname-input2">
                                Contact Person


                                </Label>
                                    <Input
                                    autoComplete="off"
                                      type="text"
                                      name="Contact_Person"
                                      className="form-control"
                                      id="basicpill-lastname-input2"
                                     
                                    
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.Contact_Person || ""}
                                      invalid={
                                        validation.touched.Contact_Person && validation.errors.Contact_Person ? true : false
                                      }
                                    />
                                       {validation.touched.Contact_Person && validation.errors.Contact_Person ? (
                          <FormFeedback type="invalid">{validation.errors.Contact_Person}</FormFeedback>
                        ) : null}
                                  </div>
                                </Col>
                                <Col lg="3">
                                  <div className="mb-3">
                                    <Label for="basicpill-lastname-input2">
                                 Address1


                                </Label>
                                <Input
                                    autoComplete="off"
                                      type="textarea"
                                      name="Address1"
                                      className="form-control"
                                      id="basicpill-lastname-input2"
                                     
                                    
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.Address1 || ""}
                                      invalid={
                                        validation.touched.Address1 && validation.errors.Address1 ? true : false
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                              <Col lg="3">
                                  <div className="mb-3">
                                    <Label for="basicpill-lastname-input2">
                                Address2


                                </Label>
                                <Input
                                    autoComplete="off"
                                      type="textarea"
                                      name="Address2"
                                      className="form-control"
                                      id="basicpill-lastname-input2"
                                     
                                    
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.Address2 || ""}
                                      invalid={
                                        validation.touched.Address2 && validation.errors.Address2 ? true : false
                                      }
                                    />
                                  </div>
                                </Col>
                        
                                <Col lg="3">
                                  <div className="mb-3">
                                    <Label for="basicpill-lastname-input2">
                                  City






                                </Label>
                                    <Input
                                    autoComplete="off"
                                      type="text"
                                      name="City"
                                      className="form-control"
                                      id="basicpill-lastname-input2"
                                     
                                      
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.City || ""}
                                      invalid={
                                        validation.touched.City && validation.errors.City ? true : false
                                      }
                                    />     {validation.touched.City && validation.errors.City ? (
                                      <FormFeedback type="invalid">{validation.errors.City}</FormFeedback>
                                    ) : null}
                             
                                  </div>
                                </Col>
                                <Col lg="3">
                                  <div className="mb-3">
                                    <Label for="basicpill-lastname-input2">
                                Pin  code
                                </Label>
                                <Input
                                    autoComplete="off"
                                      type="number"
                                      name="Area_Code"
                                      className="form-control"
                                      id="basicpill-lastname-input2"
                                     
                                      
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.Area_Code || ""}
                                      invalid={
                                        validation.touched.Area_Code && validation.errors.Area_Code ? true : false
                                      }
                                    />
                                   {validation.touched.Area_Code && validation.errors.Area_Code ? (
                          <FormFeedback type="invalid">{validation.errors.Area_Code}</FormFeedback>
                        ) : null}
                                  </div>
                                </Col>
                                <Col lg="3">
                                  <div className="mb-3">
                                    <Label for="basicpill-lastname-input2">
                                  State code
                                </Label>
                                <Input
                                    autoComplete="off"
                                      type="text"
                                      name="Country"
                                      className="form-control"
                                      id="basicpill-lastname-input2"
                                     value={statecode}
                                      disabled
                                   
                                    />
                             
                                  </div>
                                </Col>
                                <Col lg="3">
                                  <div className="mb-3">
                                    <Label for="basicpill-lastname-input2">
                                  State 
                                </Label>
                                <Select
                                name="CategoryId"
                        options={allstates}
                       //ref={categoryref}
                     classNamePrefix="select2-search-disable"
                    onChange={(value)=>  getstateid(value)}
                  defaultValue={statedefaultvalue}
                   />   
                             
                                  </div>
                                </Col>
                              

                                <Col lg="3">
                                  <div className="mb-3">
                                    <Label for="basicpill-lastname-input2">
                               Country







                                </Label>
                                    <Input
                                    autoComplete="off"
                                      type="text"
                                      name="Country"
                                      className="form-control"
                                      id="basicpill-lastname-input2"
                                     
                                      
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.Country || ""}
                                      invalid={
                                        validation.touched.Country && validation.errors.Country ? true : false
                                      }
                                    />
                                 {validation.touched.Country && validation.errors.Country ? (
                          <FormFeedback type="invalid">{validation.errors.Country}</FormFeedback>
                        ) : null}
                                  </div>
                                </Col>
                                <Col lg="3">
                                  <div className="mb-3">
                                    <Label for="basicpill-lastname-input2">
                                Email Id







                                </Label>
                                    <Input
                                    autoComplete="off"
                                      type="text"
                                      name="EmailId"
                                      className="form-control"
                                      id="basicpill-lastname-input2"
                                     
                                      
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.EmailId || ""}
                                      invalid={
                                        validation.touched.EmailId && validation.errors.EmailId ? true : false
                                      }
                                    />
                               {validation.touched.EmailId && validation.errors.EmailId ? (
                          <FormFeedback type="invalid">{validation.errors.EmailId}</FormFeedback>
                        ) : null}
                                  </div>
                                </Col>
                                <Col lg="3">
                                  <div className="mb-3">
                                    <Label for="basicpill-lastname-input2">
                              GSTIN







                                </Label>
                                    <Input
                                    autoComplete="off"
                                      type="text"
                                      name="TIN_No"
                                      className="form-control"
                                      id="basicpill-lastname-input2"
                                     
                                      
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.TIN_No || ""}
                                      invalid={
                                        validation.touched.TIN_No && validation.errors.TIN_No ? true : false
                                      }
                                    />
                          
                                  </div>
                                </Col>



                                <Col lg="3">
                                  <div className="mb-3">
                                    <Label for="basicpill-lastname-input2">
                             Phone

                             </Label>
                             <Input
                                    autoComplete="off"
                                      type="number"
                                      name="Phone"
                                      className="form-control"
                                      id="basicpill-lastname-input2"
                                     
                                      
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.Phone || ""}
                                      invalid={
                                        validation.touched.Phone && validation.errors.Phone ? true : false
                                      }
                                    />

{validation.touched.Phone && validation.errors.Phone ? (
                          <FormFeedback type="invalid">{validation.errors.Phone}</FormFeedback>
                        ) : null}



                       
                                  </div>
                                </Col>


                                <Col lg="3">
                                  <div className="mb-3">
                                    <Label for="basicpill-lastname-input2">
                               Fax No
                                </Label>
                                <Input
                                    autoComplete="off"
                                      type="text"
                                      name="Fax"
                                      className="form-control"
                                      id="basicpill-lastname-input2"
                                     
                                      
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.Fax || ""}
                                      invalid={
                                        validation.touched.Fax && validation.errors.Fax ? true : false
                                      }
                                    />
                         
                                  </div>
                                </Col>




                                <Col lg="3">
                                  <div className="mb-3">
                                    <Label for="basicpill-lastname-input2">
                            PAN NO







                                </Label>
                                <Input
                                    autoComplete="off"
                                      type="text"
                                      name="PANNo"
                                      className="form-control"
                                      id="basicpill-lastname-input2"
                                     
                                      
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.PANNo || ""}
                                      invalid={
                                        validation.touched.PANNo && validation.errors.PANNo ? true : false
                                      }
                                    />
                               
                                  </div>
                                </Col>

                        
                              
                              </Row>
                              <Row>
                              <div className="text-end">
                      {!!isEdit ?(
                      <button
                        type="submit"
                        className="btn btn-success save-user"
                        onClick={(e)=> {

                      
                          e.preventDefault();
                          validation.handleSubmit();
                          return false; 
                          
                          }}
                      >
                        Update
                      </button>
                      ):
                      <button
                      type="submit"
                      className="btn btn-success save-user"
                      onClick={(e)=> {

                      
                        e.preventDefault();
                        validation.handleSubmit();
                        return false; 
                        
                        }}
                    >
                      Add 
                    </button>}
                    </div>
                              </Row>
            </ModalBody>
          </Modal>
        </div>
      </div>
      {duplicateerro ? (
                    <SweetAlert
                      title="Transport  Already exists "
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      danger
                      onConfirm={() => {
                        setduplicateerro(false);
                      }}
                    ></SweetAlert>
                  ) : null}


{coutrysuccess ? (
                    <SweetAlert
                      title="Transport Added Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setcoutrysuccess(false);
                      }}
                    ></SweetAlert>
                  ) : null}
                  
      {countryinfo ? (
                    <SweetAlert
                      title="Transport Updated Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setcountryinfo(false);
                      }}
                    ></SweetAlert>
                  ) : null}
                  
      {countryerror ? (
                    <SweetAlert
                      title="Transport Deleted Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setcountryerror(false);
                      }}
                    ></SweetAlert>
                  ) : null}


<Backdrop  open={dialogbox} className={classes.backdrop} >
      <Spinner name="ball-spin-fade-loader"  color='#fafafa' />

     </Backdrop>
     <Dialog  onClose={Closepopup}  aria-labelledby="simple-dialog-title" open={open}>
     <img  src={Poupuimage}  style={{width:'500px', height:'500px'  }} />
    </Dialog>
    </React.Fragment>
  )
}
DatatableTables.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default DatatableTables
